// extracted by mini-css-extract-plugin
export default {"sidebarItems":"SidebarContent_sidebarItems__x67YQ","active":"SidebarContent_active__aM+9y","exitButton":"SidebarContent_exitButton__Az8F0"};